
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 132664"}},[_c('path',{attrs:{"data-name":"Path 147240","d":"M18.625 12.125H17.5V8.75a4.486 4.486 0 00-4.5-4.5 4.486 4.486 0 00-4.5 4.5v3.375H7.375a2.266 2.266 0 00-2.25 2.25V20a2.266 2.266 0 002.25 2.25h11.25a2.266 2.266 0 002.25-2.25v-5.625a2.266 2.266 0 00-2.25-2.25zm-9-3.375A3.376 3.376 0 0113 5.375a3.376 3.376 0 013.375 3.375v3.375h-6.75zM19.75 20a1.111 1.111 0 01-1.125 1.125H7.375A1.111 1.111 0 016.25 20v-5.625a1.111 1.111 0 011.125-1.125h11.25a1.111 1.111 0 011.125 1.125z","fill":"#bac1cc"}})])])
          )
        }
      }
    